import {AVM1PropertyFlags, alIsFunction, wrapAVM1NativeClass, AVM1Context, AVM1Object} from "@awayfl/avm1";
import { AudioManager } from "@awayjs/core";

declare var PokiSDK:any;


export class AVM1PokiSDK extends AVM1Object {

	public static createAVM1Class(context: AVM1Context): AVM1Object {
		var wrapped = wrapAVM1NativeClass(context, true, AVM1PokiSDK,
			['init', 'isAdBlocked', 'gameLoadingStart', 'gameLoadingFinished', 'commercialBreak', 'gameplayStart', 'gameplayStop'],[],
			null, AVM1PokiSDK.prototype.avm1Constructor);
		return wrapped;
	}

	public avm1Constructor() {
    }

	public static init(context, myTarget, callbackName) {
        var callback=function(adsBlocked){};
		if(myTarget!=null && callbackName!=null){
            callback=function(adsBlocked){
                var desc=myTarget.alGet(callbackName.toLowerCase());
                if(desc && alIsFunction(desc))
                    desc.alCall(myTarget, [adsBlocked]);
                else if (desc && desc.value)
                    desc.value.alCall(myTarget, [adsBlocked]);
            }
        };
        PokiSDK.init().then(
            () => {
                // successfully initialized
                callback(false);
                console.log("PokiSDK initialized");
            }   
        ).catch(
            () => {
                // initialized but the user has an adblock
                callback(true);
            }   
        );
        PokiSDK.setDebug(true);
	}
	public static isAdBlocked() {
        if(!PokiSDK.hasOwnProperty("adBlocked")){
            throw("AS2 is trying to use the PokiSDK before it has been init")
        }
        return PokiSDK.adBlocked;
    }
    
	public static gameLoadingStart() {
        if(!PokiSDK.hasOwnProperty("adBlocked")){
            throw("AS2 is trying to use the PokiSDK before it has been init")
        }
        PokiSDK.gameLoadingStart();
    }
    
	public static gameLoadingFinished() {
        if(!PokiSDK.hasOwnProperty("adBlocked")){
            throw("AS2 is trying to use the PokiSDK before it has been init")
        }
        PokiSDK.gameLoadingFinished();
    }
	public static gameplayStart() {
        if(!PokiSDK.hasOwnProperty("adBlocked")){
            throw("AS2 is trying to use the PokiSDK before it has been init")
        }
        PokiSDK.gameplayStart();
    }
    
	public static gameplayStop() {
        if(!PokiSDK.hasOwnProperty("adBlocked")){
            throw("AS2 is trying to use the PokiSDK before it has been init")
        }
        PokiSDK.gameplayStop();
    }
    
    
    public static commercialBreak(context, myTarget, callback) {
        AudioManager.setVolume(0);
        if(!PokiSDK.hasOwnProperty("adBlocked")){
            throw("AS2 is trying to use the PokiSDK before it has been init")
        }
        var callback2=function(){};
		if(myTarget!=null && callback!=null){
            callback2=function(){
                callback.alCall(myTarget);
            }
        };
        PokiSDK.commercialBreak().then(
            () => {
                // commercialBreak finished
                AudioManager.setVolume(1);
                callback2();
                console.log("PokiSDK commercialBreak finished");
            }   
        );
    }
    public static happyTime(context, intensity) {
        PokiSDK.happyTime(intensity);
    }
}